import React, { useState } from "react";
import "../css/SaharaCampaign.css";

const SaharaCampaign = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="campaign-premium-wrapper">
      {}
      <div className="campaign-modern-navbar">
        <button
          className={`nav-tab-item ${activeTab === "overview" ? "tab-state-active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <span className="tab-emoji">🚀</span> Overview
        </button>
        <button
          className={`nav-tab-item ${activeTab === "impact" ? "tab-state-active" : ""}`}
          onClick={() => setActiveTab("impact")}
        >
          <span className="tab-emoji">🎯</span> Imapct
        </button>
        <button
          className={`nav-tab-item ${activeTab === "story" ? "tab-state-active" : ""}`}
          onClick={() => setActiveTab("story")}
        >
          <span className="tab-emoji">❤️</span> Story
        </button>
        <button
          className={`nav-tab-item ${activeTab === "updates" ? "tab-state-active" : ""}`}
          onClick={() => setActiveTab("updates")}
        >
          <span className="tab-emoji">📢</span> Updates
        </button>
      </div>

      {}
      <div className="campaign-display-body">
        {}
        {activeTab === "overview" && (
          <div className="view-transition-node">
            <div className="badge-pill-accent">ACTIVE CAMPAIGN</div>
            <h2 className="display-main-title">
              About This Campaign: Intrest Free loan for Sahara Public Secondary
              School
            </h2>

            <div className="card-glass-panel core-story">
              <p className="lead-narrative-text">
                Sahara Public Secondary School, located in Krishna Nagar,
                Kapilvastu, Nepal, is dedicated to delivering quality education
                to its students. However, due to financial limitations, the
                school is currently facing challenges in maintaining smooth
                operations and upgrading essential facilities.
              </p>
              <p className="lead-narrative-text">
                To ensure continued educational excellence and institutional
                sustainability, the school seeks to raise NPR 500,000 as an
                interest-free loan for one year. This financial support will
                enable the school to address immediate operational needs,
                continue its development activities, and maintain a conducive
                learning environment for students. Lenders will be provided with
                official receipts, and even small contributions—starting from
                NPR 10—will be highly appreciated.
              </p>
            </div>

            {}
            <div className="dual-pillar-grid">
              <div className="pillar-card challenge">
                <div className="pillar-header">
                  <span className="pillar-bullet red"></span>
                  <h3>Our Challenge</h3>
                </div>
                <p>
                  With a growing number of students, Sahara Public Secondary
                  School is under increasing pressure to maintain its
                  educational standards while managing limited financial
                  resources. The school faces difficulties in covering
                  operational expenses, maintaining infrastructure, and
                  upgrading essential facilities such as classrooms, the
                  computer lab, science lab, and library. The lack of a
                  financial reserve or emergency fund has made it challenging to
                  ensure stability and uninterrupted learning. Without timely
                  support, the school risks disruptions that could affect both
                  academic quality and student welfare.
                </p>
              </div>

              <div className="pillar-card solution">
                <div className="pillar-header">
                  <span className="pillar-bullet green"></span>
                  <h3>Our Solution</h3>
                </div>
                <p>
                  To overcome these financial constraints, Sahara Public
                  Secondary School plans to establish a School Reserve Fund
                  supported by an interest-free loan of NPR 500,000 from
                  well-wishers and community members. This fund will provide the
                  liquidity needed to sustain daily operations, manage urgent
                  expenses, and continue ongoing development
                  projects—particularly the construction of the first floor of
                  the school building. The loan will be fully repaid within one
                  year, and every contributor will receive an official receipt
                  as acknowledgment. This initiative encourages collective
                  participation, allowing individuals to contribute according to
                  their capacity, even as little as NPR 10, to strengthen the
                  school's foundation.
                </p>
              </div>
            </div>

            <div className="pillar-card long-term full-width-pillar">
              <div className="pillar-header">
                <span className="pillar-bullet gold"></span>
                <h3>Long-term Impact</h3>
              </div>
              <p>
                The establishment of the School Reserve Fund will ensure
                financial stability and long-term sustainability for Sahara
                Public Secondary School. By securing short-term liquidity and
                building a culture of community support, the school will be
                better equipped to manage future challenges, maintain
                facilities, and invest in academic improvements. Improved
                financial resilience will lead to enhanced learning
                environments, motivated teachers, and better educational
                outcomes for students. Ultimately, this initiative will not only
                safeguard the school's future but also empower the broader
                community by nurturing educated, capable, and responsible
                citizens of Nepal.
              </p>
            </div>
          </div>
        )}

        {}
        {activeTab === "impact" && (
          <div className="view-transition-node">
            <h3 className="section-block-subtitle">📊 Analytics Dashboard</h3>
            <div className="metrics-dashboard-grid">
              <div className="metric-glass-card">
                <div className="metric-icon-holder purple">🧑‍🎓</div>
                <div className="metric-giant-number">500+</div>
                <div className="metric-caption-string">STUDENTS SUPPORTED</div>
              </div>

              <div className="metric-glass-card">
                <div className="metric-icon-holder blue">🏫</div>
                <div className="metric-giant-number">25</div>
                <div className="metric-caption-string">SCHOOLS PARTNERED</div>
              </div>

              <div className="metric-glass-card">
                <div className="metric-icon-holder gold">📜</div>
                <div className="metric-giant-number">150</div>
                <div className="metric-caption-string">SCHOLARSHIPS GIVEN</div>
              </div>

              <div className="metric-glass-card">
                <div className="metric-icon-holder green">✅</div>
                <div className="metric-giant-number">80</div>
                <div className="metric-caption-string">MENTORS ACTIVE</div>
              </div>
            </div>
          </div>
        )}

        {}
        {activeTab === "story" && (
          <div className="view-transition-node">
            <h3 className="section-block-subtitle">
              💖 Community Testimonials
            </h3>
            <div className="testimonials-luxury-column">
              <div className="testimonial-luxury-card">
                <div className="profile-badge-circle text-orange">PS</div>
                <div className="testimonial-text-side">
                  <div className="author-meta-block">
                    <h4>Priya S.</h4>
                    <span className="age-pill-tag">Age 14</span>
                  </div>
                  <p className="testimonial-quote-string">
                    "Thanks to the Education Fund, I received books and
                    mentorship that helped me excel in my studies. I'm now
                    preparing for engineering entrance exams!"
                  </p>
                </div>
              </div>

              <div className="testimonial-luxury-card">
                <div className="profile-badge-circle text-blue">AK</div>
                <div className="testimonial-text-side">
                  <div className="author-meta-block">
                    <h4>Arjun K.</h4>
                    <span className="age-pill-tag">Age 16</span>
                  </div>
                  <p className="testimonial-quote-string">
                    "The computer literacy program opened new doors for me. I
                    can now help my family with digital tasks and dream of a
                    career in technology."
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {}
        {activeTab === "updates" && (
          <div className="view-transition-node">
            <h3 className="section-block-subtitle">
              📋 Campaign Timeline Feed
            </h3>
            <div className="timeline-corporate-track">
              <div className="timeline-corporate-node">
                <div className="node-icon-bullet blue-glow">🏗️</div>
                <div className="node-content-box">
                  <div className="node-header-flex">
                    <h4>New Infrastructure Layer Initiated</h4>
                    <span className="node-time-tag">📅 June 05, 2026</span>
                  </div>
                  <p>
                    First floor slab framework adjustments for the primary
                    secondary academic blocks have formally commenced. Funding
                    streams from the Reserve Allocation are being smoothly
                    deployed.
                  </p>
                </div>
              </div>

              <div className="timeline-corporate-node">
                <div className="node-icon-bullet gold-glow">💰</div>
                <div className="node-content-box">
                  <div className="node-header-flex">
                    <h4>NPR 150,000 Milestone Cleared</h4>
                    <span className="node-time-tag">📅 May 28, 2026</span>
                  </div>
                  <p>
                    Thanks to community well-wishers and rural development
                    leaders, we have crossed 30% of our targeted interest-free
                    reserve loan framework pool safely.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {}
      <div className="campaign-sticky-status-strip">
        <div className="status-node">
          <span className="status-digits text-violet">500+</span>
          <span className="status-label">Students Impacted</span>
        </div>
        <div className="status-line-separator"></div>
        <div className="status-node">
          <span className="status-digits text-teal">15+</span>
          <span className="status-label">Smart Classes</span>
        </div>
        <div className="status-line-separator"></div>
        <div className="status-node">
          <span className="status-digits text-amber">80G</span>
          <span className="status-label">Tax Benefit</span>
        </div>
      </div>
    </div>
  );
};

export default SaharaCampaign;
